export default __webpack_public_path__ + "static/media/configuration.9b327339.svg";